import { createFileRoute } from '@tanstack/react-router'
import { PartnersPage } from '~/features/admin/partners-page'

export const Route = createFileRoute('/admin/partners/')({
  component: PartnersPage,
})
